



// 方形加号——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `icon/fadd/index${i + 1}`,
  name: `icon/faddIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/fadd/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 方形加号——主流程，开始
    ...MainRoutes,
  ],
};
